import { Component } from '@theme/component';
import { ensureGsap } from '@akr/animate-gsap';

/**
 * Footer social circle: media fades in/dot pops in on hover, driven by GSAP
 * instead of CSS transitions so the video pause on leave can wait for the
 * fade-out to actually finish instead of cutting the frame mid-transition.
 * The video only plays while hovered (autoplay would burn bandwidth/CPU on
 * a clip that's invisible — opacity: 0 — most of the time).
 */
export class FooterSocial extends Component {
  async enter(event) {
    if (event.pointerType !== 'mouse') return;

    this.querySelector('video')?.play();

    await ensureGsap();
    gsap.to(this.querySelector('.AkrFooterSocial-media'), {
      opacity: 0.4,
      duration: 0.3,
      ease: 'power2.out',
    });
    gsap.to(this.querySelector('.AkrPreorderFooter-dot'), {
      opacity: 1,
      scale: 1,
      duration: 0.4,
      ease: 'back.out(1.7)',
    });
  }

  async leave(event) {
    if (event.pointerType !== 'mouse') return;

    await ensureGsap();
    gsap.to(this.querySelector('.AkrFooterSocial-media'), {
      opacity: 0,
      duration: 0.3,
      ease: 'power2.out',
      onComplete: () => {
        const video = this.querySelector('video');
        if (!video) return;

        video.pause();
        video.currentTime = 0;
      },
    });
    gsap.to(this.querySelector('.AkrPreorderFooter-dot'), {
      opacity: 0,
      scale: 0,
      duration: 0.25,
      ease: 'power2.out',
    });
  }
}

customElements.define('akr-footer-social', FooterSocial);
